export default function Join() {
  return (
    <section id="join" className="w-full bg-background-50 px-4 md:px-6 py-12 md:py-16">
      <div className="mx-auto max-w-6xl rounded-3xl overflow-hidden relative w-full">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20coral%20orange%20and%20cream%20abstract%20celebration%20banner%20with%20confetti%20and%20soft%20bubbles%2C%20playful%20community%20join%20theme%2C%20modern%20minimal%20editorial%20design%2C%20bright%20welcoming%20atmosphere%2C%20no%20text&width=1400&height=620&seq=join-cta-2026&orientation=landscape"
          alt="加入吃瓜17社区 背景插画"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-500/90 via-primary-500/70 to-accent-500/70" aria-hidden="true"></div>
        <div className="relative px-6 md:px-12 py-12 md:py-16 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl md:text-4xl font-black text-background-50 leading-snug">
              别只当围观群众
              <br />
              下一个热门话题，等你来开麦
            </h2>
            <p className="mt-3 text-sm md:text-base text-primary-100/90 max-w-md mx-auto md:mx-0 leading-relaxed">
              注册即送社区新人大礼包，加入你感兴趣的板块，与上万名瓜友一起围观、讨论、交朋友。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row md:flex-col xl:flex-row gap-3 md:gap-4">
            <a
              href="#board"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-background-50 hover:bg-background-100 text-primary-700 text-base font-bold whitespace-nowrap transition-colors"
            >
              <i className="ri-user-add-line text-lg" aria-hidden="true"></i> 免费注册
            </a>
            <a
              href="#board"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border-2 border-background-50/80 hover:bg-background-50/20 text-background-50 text-base font-bold whitespace-nowrap transition-colors"
            >
              逛逛再决定 <i className="ri-arrow-right-line text-lg" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}